export const appContextTypes = {
  SET_INTENTION_TAG_DETAILS: "SET_INTENTION_TAG_DETAILS",
  RESET_TOAST: "RESET_TOAST",
  SET_TOAST: "SET_TOAST",
  SET_USERINPUT: "SET_USERINPUT",
  SET_SELECTED_PLOTCARD: "SET_SELECTED_PLOTCARD",
};
